export function RadarAnimation() {
  return (
    <div className="relative flex h-full w-full items-center justify-center overflow-hidden">
      {Array.from({ length: 6 }).map((_, i) => (
        <div
          key={i}
          className={`animate-radar absolute inset-0 rounded-full border border-transparent`}
          style={{ animationDelay: `${i * 1}s` }}
        />
      ))}
    </div>
  )
}
